import { cut } from '@testing-library/user-event/dist/types/clipboard'
import type { OrderRequestSelectedSite } from './types'
import moment from 'moment'

export function formatTimeRange(window: OrderRequestSelectedSite['fixed_windows'][number], timezone: string) {
  const startTime = moment(window.start_time).tz(timezone).format('h:mm A')
  const endTime = moment(window.end_time).tz(timezone).format('h:mm A')
  return `${startTime} - ${endTime}`
}

export function formatWindowOption(
  window: OrderRequestSelectedSite['fixed_windows'][number],
  timezone: string,
  isDisabled: boolean
) {
  return {
    value: `${window.start_time}|${window.end_time}`,
    label: formatTimeRange(window, timezone),
    display: formatTimeRange(window, timezone),
    disabled: isDisabled,
  }
}

export function isWindowDisabled(
  window: OrderRequestSelectedSite['fixed_windows'][number],
  selectedDate: string | null, // This date comes from Ant Design DatePicker in local timezone
  selectedSite: OrderRequestSelectedSite | null
) {
  if (!selectedDate || !selectedSite) return false

  // Clone moment objects to avoid mutations
  let startTime = moment(window.start_time).tz(selectedSite.timezone)
  let endTime = moment(window.end_time).tz(selectedSite.timezone)
  let cutoffTime = moment(window.cutoff_time).tz(selectedSite.timezone)

  // Current time in site timezone
  const currentTimeInSiteTimezone = moment().tz(selectedSite.timezone)

  // if cutoff time has passed, we need to adjust the window time to the next day
  if (currentTimeInSiteTimezone.isAfter(cutoffTime)) {
    startTime = startTime.clone().add(1, 'day')
    endTime = endTime.clone().add(1, 'day')
    cutoffTime = cutoffTime.clone().add(1, 'day')
  }

  // Convert selectedDate to a moment in site timezone, preserving the date part only
  const selectedDateInSiteTimezone = moment.tz(selectedDate, selectedSite.timezone).startOf('day')
  const windowDateInSiteTimezone = startTime.clone().startOf('day')

  // Compare just the dates
  return selectedDateInSiteTimezone.isBefore(windowDateInSiteTimezone)
}
